export default "__VITE_ASSET__CN78mhx2__"